<template>
  <div>
    <map-screen :modulePropsData="modulePropsData" v-if="shouldShowMapScreen" />

    <manual-location
      :modulePropsData="modulePropsData"
      v-if="shouldShowManualLocation"
    />

    <take-away-page
      :modulePropsData="modulePropsData"
      v-if="shouldShowTakeAwayPage"
    />

    <div v-if="showAskLocationModal">
      <ask-location />
    </div>
  </div>
</template>

<script>
// import { defineAsyncComponent } from "vue";
import ManualLocation from "./ManualLocation.vue";
import MapScreen from "./MapScreen.vue";
import { isGoogleMapLoaded, load } from "../helpers/landingUtils";
import { googleApiEndpoints, clientPlatform } from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import { OrderTypesCode } from "../helpers/orderTypesConstants";
import TakeAwayPage from "./TakeAwayPage.vue";
import AskLocation from "./AskLocation.vue";
import { LocationPageStaticKeys } from "../helpers/addressConstants";

export default {
  name: "LocationPage",
  components: {
    MapScreen,
    ManualLocation,
    TakeAwayPage,
    AskLocation,
  },
  props: {
    autoLocate: { type: Boolean, default: false },
    moduleProps: {
      required: false,
      default: LocationPageStaticKeys,
    },
  },
  data() {
    return {
      clientPlatform,
      isLocateMeDisabled: false,
      showAskLocationModal: false,
      parsedResults: [],
      showAlwaysOnDesktop: clientPlatform == "Web" ? true : false,
      modulePropsData: {},
    };
  },
  beforeMount() {
    if (typeof window.google === "undefined") {
      this.loadMap();
    } else {
      this.onPageLoad();
    }
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    this.parsedResults = Utility.getCartDataInMenuServiceFormat(
      LocalStorageFunc.getCart()
    );
    this.checkLocationPermissions(this, this.setGPSLocation);
    this.processResultDataForStore(this.parsedResults);
  },
  methods: {
    processResultDataForStore(data) {
      this.$store.commit(keyMapsMutation.UPDATE_PRODUCTS_IN_STORE, data);
      this.$store.commit(keyMapsMutation.LOAD_CART_FROM_STORAGE_SERVICE, {});
    },
    loadMap(count = 0) {
      if (isGoogleMapLoaded()) {
        this.onGoogleMapLoad();
        this.onPageLoad();
      } else if (count < 3) {
        load(googleApiEndpoints.MAP_URL)
          .then(() => {
            this.onGoogleMapLoad();
            this.onPageLoad();
          })
          .catch(() => {
            this.loadMap(++count);
          });
      }
    },
    onGoogleMapLoad() {
      if (!Utility.checkTriggerLocationScreenForAddEditAddress()) {
        if (this.autoLocate) {
          this.locateMe();
        }
        this.isLocateMeDisabled = false;
      }
    },
    onPageLoad() {
      if (Utility.checkTriggerLocationScreenForAddEditAddress()) {
        if (Utility.checkEditAddressOnLocation()) {
          let editAddressObj = Utility.tryJsonParse(
            JSON.stringify(LocalStorageFunc.getEditAddress())
          );
          if (
            editAddressObj?.longitude &&
            editAddressObj?.latitude &&
            !this.isChangeAddressTriggeredInAddEditAddressFlow
          ) {
            this.$store.dispatch(keyMapsAction.DETECT_CURRENT_LOCATION, {
              showDeliveryMapScreen: true,
              lng: editAddressObj?.longitude,
              lat: editAddressObj?.latitude,
              setLocationOfEditAddress: true,
              triggerEditAddress: true,
            });
          } else if (
            editAddressObj?.longitude == 0 &&
            editAddressObj?.latitude == 0 &&
            !this.isChangeAddressTriggeredInAddEditAddressFlow
          ) {
            this.$store.dispatch(keyMapsAction.DETECT_CURRENT_LOCATION, {
              showDeliveryMapScreen: true,
              lng: editAddressObj?.longitude,
              lat: editAddressObj?.latitude,
              setLocationOfEditAddress: true,
              triggerEditAddress: true,
            });
          }
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN,
            true
          );
        } else {
          if (
            LocalStorageFunc.getCoordsFromRecentLocation()?.coords?.latitude
          ) {
            // if location is already selected
            let query = {
              coords: LocalStorageFunc.getCoordsFromRecentLocation()?.coords,
              showDeliveryMapScreen: true,
            };
            this.$store.dispatch(keyMapsAction.GEO_CODE_API_COMBO, query);
          } else {
            this.$store.dispatch(keyMapsAction.DETECT_CURRENT_LOCATION, {
              showDeliveryMapScreen: true,
            });
          }
        }
        if (this.addAddressEnable) {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN,
            true
          );
        }
      }
    },
    locateMe() {
      this.$store.dispatch(keyMapsAction.DETECT_CURRENT_LOCATION, {
        showDeliveryMapScreen: false,
        setGeoCode:
          (this.orderTypeDeliverySelected || this.showManualLocationScreen) &&
          !this.selectedUserAddress &&
          !this.selectedStoreForTakeawayOrDinein,
        triggerTakeAway: this.orderTypeTakeAwaySelected,
        triggerDineIn: this.orderTypeDineInSelected,
        setStoreByDefault: this.orderTypeTakeAwayOrDineIn,
      });
    },
    checkLocationPermissions(PContext, inputFunc) {
      if (navigator.permissions) {
        navigator.permissions
          .query({ name: "geolocation" })
          .then(function (PermissionStatus) {
            if (PermissionStatus.state == "granted") {
              LocalStorageFunc.setIsLocationPermissionGiven();
              PContext.$store.commit(
                keyMapsMutation.UPDATE_IS_LOCATION_PERMISSION_GIVEN,
                true
              );
              inputFunc();
              //console.log("allowed")
            } else if (PermissionStatus.state == "prompt") {
              //console.log("prompt");
              LocalStorageFunc.unsetKey("isLocationPermissionGiven");
              PContext.$store.commit(
                keyMapsMutation.UPDATE_IS_LOCATION_PERMISSION_GIVEN,
                false
              );
            } else {
              //console.log("denied");
              LocalStorageFunc.unsetKey("isLocationPermissionGiven");
              PContext.$store.commit(
                keyMapsMutation.UPDATE_IS_LOCATION_PERMISSION_GIVEN,
                false
              );
            }
          });
      }
    },
    setGPSLocation() {
      // let currentGPSLocation = LocalStorageFunc.getCurrentGPSLocation();
      // if (!currentGPSLocation.footerAddress) {
      this.$store.dispatch(keyMapsAction.SAVE_CURRENT_GPS_LOCATION);
      // }
    },
  },
  computed: {
    showDeliveryMapScreen() {
      return this.$store.state.Location.showDeliveryMapScreen;
    },

    showManualLocationScreen() {
      return this.$store.state.Location.showManualLocationScreen;
    },

    orderTypeDeliverySelected() {
      let orderType =
        LocalStorageFunc.getSelectedDeliveryType() ||
        LocalStorageFunc.getDeliveryType();
      return orderType === OrderTypesCode.DELIVERY_CODE;
    },

    orderTypeTakeAwaySelected() {
      let orderType =
        LocalStorageFunc.getSelectedDeliveryType() ||
        LocalStorageFunc.getDeliveryType();
      return orderType === OrderTypesCode.TAKEAWAY_CODE;
    },

    orderTypeDineInSelected() {
      let orderType =
        LocalStorageFunc.getSelectedDeliveryType() ||
        LocalStorageFunc.getDeliveryType();
      return orderType === OrderTypesCode.DINE_IN_CODE;
    },
    isChangeAddressTriggeredInAddEditAddressFlow() {
      return LocalStorageFunc.getIsChangeAddressTriggeredInAddEditAddressFlow();
    },
    getEditAddress() {
      return LocalStorageFunc.getEditAddress();
    },
    showEditAddressFlow() {
      return Object.keys(this.getEditAddress).length;
    },
    isAddEditAddressModal() {
      return LocalStorageFunc.getIsAddEditAddressFlow();
    },
    shouldShowMapScreen() {
      return (
        this.showDeliveryMapScreen &&
        (this.orderTypeDeliverySelected ||
          this.showManualLocationScreen ||
          this.isAddEditAddressModal)
      );
    },
    shouldShowManualLocation() {
      return (
        ((!this.showDeliveryMapScreen || this.showAlwaysOnDesktop) &&
          (this.orderTypeDeliverySelected || this.showManualLocationScreen)) ||
        (this.isAddEditAddressModal && this.showManualLocationScreen)
      );
    },
    shouldShowTakeAwayPage() {
      return (
        this.orderTypeTakeAwayOrDineIn &&
        !this.showManualLocationScreen &&
        !this.isAddEditAddressModal
      );
    },
    orderTypeTakeAwayOrDineIn() {
      return this.orderTypeTakeAwaySelected || this.orderTypeDineInSelected;
    },
    selectedUserAddress() {
      return LocalStorageFunc.getSelectedUserAddress();
    },
    selectedStoreForTakeawayOrDinein() {
      return LocalStorageFunc.getSelectedStore();
    },
    addAddressEnable() {
      return LocalStorageFunc.getAddAddressEnable();
    },
  },
};
</script>
